<template>
  <div class="container-fluid">
    <div class="block-header">
      <bread-crumb></bread-crumb>
    </div>

    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card card-top-line">
          <ValidationObserver v-slot="{ passes }">
            <div class="header">
              <h2>Create Role</h2>
            </div>
            <div class="body">
              <form @submit.prevent="passes(createRole)" id="basic-form">
                <ValidationProvider
                  name="name"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <div
                    class="form-group"
                    :class="{
                      errors: errors.length && !role.name,
                      success: role.name,
                    }"
                  >
                    <span class="float-label">
                      <input
                        type="text"
                        v-model="role.name"
                        class="form-control"
                        id="name"
                        placeholder="First Name*"
                      />
                      <label for="name" class="control-label">Name*</label>
                      <div class="line"></div>
                      <i
                        class="fa fa-times"
                        v-if="errors.length && !role.name"
                      ></i>
                      <i class="fa fa-check" v-if="role.name"></i>
                    </span>
                  </div>
                </ValidationProvider>
                <div class="form-group">
                  <label>Permissions:</label>
                  <div class="pl-5">
                    <div
                      class="checkbox-wrapper d-flex row"
                      v-for="(item, index) in role.premissions"
                      :key="index"
                    >
                      <label class="mr-2 col-2">{{ item.name }}</label>
                      <label class="fancy-checkbox element-left col-2">
                        <input
                          type="checkbox"
                          name="readonly"
                          v-model="item.options.readonly"
                          @click="check(index, 'readonly')"
                        />
                        <span>Read</span>
                      </label>
                      <label class="fancy-checkbox element-left col-2">
                        <input
                          type="checkbox"
                          name="readWrite"
                          v-model="item.options.readWrite"
                          @click="check(index, 'readWrite')"
                        />
                        <span>Read & Write</span>
                      </label>
                      <label class="fancy-checkbox element-left col-2">
                        <input
                          type="checkbox"
                          name="readWrite"
                          v-model="item.options.delete"
                        />
                        <span>Delete</span>
                      </label>
                    </div>
                  </div>
                </div>
                <div
                  class="d-flex flex-column flex-md-row justify-content-center"
                >
                  <b-button
                    variant="secondary btn-mw"
                    size="lg"
                    @click="$router.push({ path: '/user-managment/roles' })"
                  >
                    Cancel
                  </b-button>
                  <b-button
                    type="submit"
                    variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                    size="lg"
                  >
                    Submit
                  </b-button>
                </div>
              </form>
            </div>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const { ValidationObserver, ValidationProvider } = require("vee-validate");
export default {
  name: "CreateRoleComponent",
  components: {
    ValidationObserver,
    ValidationProvider,
    BreadCrumb: () => import("@/components/BreadCrumb.vue"),
  },
  data() {
    return {
      role: {
        name: "",
        premissions: [
          {
            name: "Dashboard",
            options: {
              readonly: false,
              readWrite: false,
              delete: false,
            },
          },
          {
            name: "Listing",
            options: {
              readonly: false,
              readWrite: false,
              delete: false,
            },
          },
          {
            name: "Transaction list",
            options: {
              readonly: false,
              readWrite: false,
              delete: false,
            },
          },
          {
            name: "Customer",
            options: {
              readonly: false,
              readWrite: false,
              delete: false,
            },
          },
          {
            name: "Partner",
            options: {
              readonly: false,
              readWrite: false,
              delete: false,
            },
          },
        ],
      },
    };
  },
  methods: {
    createRole() {
      console.log(this.role);
    },
    check(index, type) {
      if (type == "readWrite") {
        this.role.premissions[index].options.readonly = false;
      }
      if (type == "readonly") {
        this.role.premissions[index].options.readWrite = false;
      }
    },
  },
  mounted() {
    //
  },
};
</script>
